/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_404_LeadInputs */

const en_cmp_404_lead = /** @type {(inputs: Cmp_404_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We haven't written a page comparing Bystep to that tool yet.`)
};

const id_cmp_404_lead = /** @type {(inputs: Cmp_404_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami belum menulis halaman perbandingan Bystep dengan alat itu.`)
};

/**
* | output |
* | --- |
* | "We haven't written a page comparing Bystep to that tool yet." |
*
* @param {Cmp_404_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_404_lead = /** @type {((inputs?: Cmp_404_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_404_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_404_lead(inputs)
	return en_cmp_404_lead(inputs)
});